module.exports = {
	"config": {
		"blogTitle": "Blog",
		"authorName": "Jimmy Yang",
		"linkPrefix": "/gatsby-starter-blog"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "",
				"stem": "_template",
				"path": "_template.js",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/_template.js",
				"isAbsolute": false
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "2015",
				"base": "docker-with-runit-1.md",
				"ext": "md",
				"name": "docker-with-runit-1",
				"extname": ".md",
				"basename": "docker-with-runit-1.md",
				"dirname": "2015",
				"stem": "docker-with-runit-1",
				"path": "2015/docker-with-runit-1.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2015/docker-with-runit-1.md",
				"isAbsolute": false
			},
			"requirePath": "2015/docker-with-runit-1.md",
			"path": "/2015/docker-with-runit-1/",
			"data": {
				"title": "Docker with Runit, Part 1: SSH",
				"author": "jimmy yang",
				"tags": [
					"docker",
					"runit",
					"ssh"
				],
				"series": "2015",
				"date": "2015-03-04T00:00:00.000Z",
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2015",
				"base": "docker-with-runit-2.md",
				"ext": "md",
				"name": "docker-with-runit-2",
				"extname": ".md",
				"basename": "docker-with-runit-2.md",
				"dirname": "2015",
				"stem": "docker-with-runit-2",
				"path": "2015/docker-with-runit-2.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2015/docker-with-runit-2.md",
				"isAbsolute": false
			},
			"requirePath": "2015/docker-with-runit-2.md",
			"path": "/2015/docker-with-runit-2/",
			"data": {
				"title": "Docker with Runit, Part 2: Rsyslog",
				"author": "jimmy yang",
				"tags": [
					"docker",
					"runit",
					"syslog"
				],
				"series": "2015",
				"date": "2015-03-05T00:00:00.000Z",
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2015",
				"base": "docker-workflow-1.md",
				"ext": "md",
				"name": "docker-workflow-1",
				"extname": ".md",
				"basename": "docker-workflow-1.md",
				"dirname": "2015",
				"stem": "docker-workflow-1",
				"path": "2015/docker-workflow-1.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2015/docker-workflow-1.md",
				"isAbsolute": false
			},
			"requirePath": "2015/docker-workflow-1.md",
			"path": "/2015/docker-workflow-1/",
			"data": {
				"title": "Docker workflow, part 1: get start",
				"author": "jimmy yang",
				"tags": [
					"docker",
					"jenkins ci"
				],
				"series": "2015",
				"date": "2015-03-06T00:00:00.000Z"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2015",
				"base": "docker-workflow-2.md",
				"ext": "md",
				"name": "docker-workflow-2",
				"extname": ".md",
				"basename": "docker-workflow-2.md",
				"dirname": "2015",
				"stem": "docker-workflow-2",
				"path": "2015/docker-workflow-2.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2015/docker-workflow-2.md",
				"isAbsolute": false
			},
			"requirePath": "2015/docker-workflow-2.md",
			"path": "/2015/docker-workflow-2/",
			"data": {
				"title": "Docker workflow, part 2: jenkins",
				"author": "jimmy yang",
				"tags": [
					"docker",
					"jenkins ci"
				],
				"series": "2015",
				"date": "2015-03-07T00:00:00.000Z"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2015",
				"base": "docker-workflow-3.md",
				"ext": "md",
				"name": "docker-workflow-3",
				"extname": ".md",
				"basename": "docker-workflow-3.md",
				"dirname": "2015",
				"stem": "docker-workflow-3",
				"path": "2015/docker-workflow-3.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2015/docker-workflow-3.md",
				"isAbsolute": false
			},
			"requirePath": "2015/docker-workflow-3.md",
			"path": "/2015/docker-workflow-3/",
			"data": {
				"title": "Docker workflow, part 3: php app",
				"author": "jimmy yang",
				"tags": [
					"docker",
					"wordpress"
				],
				"series": "2015",
				"date": "2015-03-08T00:00:00.000Z"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2015",
				"base": "jekyll.md",
				"ext": "md",
				"name": "jekyll",
				"extname": ".md",
				"basename": "jekyll.md",
				"dirname": "2015",
				"stem": "jekyll",
				"path": "2015/jekyll.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2015/jekyll.md",
				"isAbsolute": false
			},
			"requirePath": "2015/jekyll.md",
			"path": "/2015/jekyll/",
			"data": {
				"title": "Get start with jekyll and github pages !!",
				"author": "jimmy yang",
				"tags": [
					"jekyll"
				],
				"series": "2015",
				"date": "2015-05-02T00:00:00.000Z"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2015",
				"base": "launch-wordpress-in-ecs.md",
				"ext": "md",
				"name": "launch-wordpress-in-ecs",
				"extname": ".md",
				"basename": "launch-wordpress-in-ecs.md",
				"dirname": "2015",
				"stem": "launch-wordpress-in-ecs",
				"path": "2015/launch-wordpress-in-ecs.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2015/launch-wordpress-in-ecs.md",
				"isAbsolute": false
			},
			"requirePath": "2015/launch-wordpress-in-ecs.md",
			"path": "/2015/launch-wordpress-in-ecs/",
			"data": {
				"title": "Launch wordpress in aws ec2 container service",
				"author": "jimmy yang",
				"tags": [
					"docker",
					"AWS ECS",
					"wordpress"
				],
				"series": "2015",
				"date": "2015-05-09T00:00:00.000Z"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016/101",
				"base": "js-functional-programming.md",
				"ext": "md",
				"name": "js-functional-programming",
				"extname": ".md",
				"basename": "js-functional-programming.md",
				"dirname": "2016/101",
				"stem": "js-functional-programming",
				"path": "2016/101/js-functional-programming.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2016/101/js-functional-programming.md",
				"isAbsolute": false
			},
			"requirePath": "2016/101/js-functional-programming.md",
			"path": "/2016/101/js-functional-programming/",
			"data": {
				"title": "JS - functional programming",
				"author": "jimmy yang",
				"tags": [
					"js"
				],
				"series": "101",
				"date": "2017-01-03T00:00:00.000Z",
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016/101",
				"base": "js-getting-started.md",
				"ext": "md",
				"name": "js-getting-started",
				"extname": ".md",
				"basename": "js-getting-started.md",
				"dirname": "2016/101",
				"stem": "js-getting-started",
				"path": "2016/101/js-getting-started.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2016/101/js-getting-started.md",
				"isAbsolute": false
			},
			"requirePath": "2016/101/js-getting-started.md",
			"path": "/2016/101/js-getting-started/",
			"data": {
				"title": "JS - getting started",
				"author": "jimmy yang",
				"tags": [
					"js"
				],
				"series": "101",
				"date": "2017-01-01T00:00:00.000Z",
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016/101",
				"base": "js-promise-async.md",
				"ext": "md",
				"name": "js-promise-async",
				"extname": ".md",
				"basename": "js-promise-async.md",
				"dirname": "2016/101",
				"stem": "js-promise-async",
				"path": "2016/101/js-promise-async.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2016/101/js-promise-async.md",
				"isAbsolute": false
			},
			"requirePath": "2016/101/js-promise-async.md",
			"path": "/2016/101/js-promise-async/",
			"data": {
				"title": "JS - promise/async",
				"author": "jimmy yang",
				"tags": [
					"js",
					"promise"
				],
				"series": "101",
				"date": "2017-01-02T00:00:00.000Z"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016/docker",
				"base": "docker-getting-started.md",
				"ext": "md",
				"name": "docker-getting-started",
				"extname": ".md",
				"basename": "docker-getting-started.md",
				"dirname": "2016/docker",
				"stem": "docker-getting-started",
				"path": "2016/docker/docker-getting-started.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2016/docker/docker-getting-started.md",
				"isAbsolute": false
			},
			"requirePath": "2016/docker/docker-getting-started.md",
			"path": "/2016/docker/docker-getting-started/",
			"data": {
				"title": "Docker - getting started",
				"author": "jimmy yang",
				"tags": [
					"docker"
				],
				"series": "docker",
				"date": "2016-01-01T00:00:00.000Z",
				"draft": true
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016/dreaming",
				"base": "daydreaming.md",
				"ext": "md",
				"name": "daydreaming",
				"extname": ".md",
				"basename": "daydreaming.md",
				"dirname": "2016/dreaming",
				"stem": "daydreaming",
				"path": "2016/dreaming/daydreaming.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2016/dreaming/daydreaming.md",
				"isAbsolute": false
			},
			"requirePath": "2016/dreaming/daydreaming.md",
			"path": "/2016/dreaming/daydreaming/",
			"data": {
				"title": "Day Dreaming",
				"author": "jimmy yang",
				"tags": [
					"daydreaming"
				],
				"series": "dreaming",
				"date": "2017-01-02T00:00:00.000Z",
				"draft": true
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016/serverless",
				"base": "getting-started.cn.md",
				"ext": "md",
				"name": "getting-started.cn",
				"extname": ".md",
				"basename": "getting-started.cn.md",
				"dirname": "2016/serverless",
				"stem": "getting-started.cn",
				"path": "2016/serverless/getting-started.cn.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2016/serverless/getting-started.cn.md",
				"isAbsolute": false
			},
			"requirePath": "2016/serverless/getting-started.cn.md",
			"path": "/2016/serverless/getting-started.cn/",
			"data": {
				"title": "无服务器架构 (Serverless) - 开始",
				"author": "jimmy yang",
				"tags": [
					"lambda",
					"serverless"
				],
				"series": "serverless",
				"date": "2017-02-26T00:00:00.000Z",
				"lang": "cn"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016/serverless",
				"base": "getting-started.md",
				"ext": "md",
				"name": "getting-started",
				"extname": ".md",
				"basename": "getting-started.md",
				"dirname": "2016/serverless",
				"stem": "getting-started",
				"path": "2016/serverless/getting-started.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2016/serverless/getting-started.md",
				"isAbsolute": false
			},
			"requirePath": "2016/serverless/getting-started.md",
			"path": "/2016/serverless/getting-started/",
			"data": {
				"title": "Serverless - getting started",
				"author": "jimmy yang",
				"tags": [
					"lambda",
					"serverless"
				],
				"series": "serverless",
				"date": "2016-01-01T00:00:00.000Z",
				"draft": true,
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016/serverless",
				"base": "migrate-express-app-to-lambda.cn.md",
				"ext": "md",
				"name": "migrate-express-app-to-lambda.cn",
				"extname": ".md",
				"basename": "migrate-express-app-to-lambda.cn.md",
				"dirname": "2016/serverless",
				"stem": "migrate-express-app-to-lambda.cn",
				"path": "2016/serverless/migrate-express-app-to-lambda.cn.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2016/serverless/migrate-express-app-to-lambda.cn.md",
				"isAbsolute": false
			},
			"requirePath": "2016/serverless/migrate-express-app-to-lambda.cn.md",
			"path": "/2016/serverless/migrate-express-app-to-lambda.cn/",
			"data": {
				"title": "无服务器架构 (Serverless) - 把基于express的程序搬上lambda",
				"author": "jimmy yang",
				"tags": [
					"lambda",
					"serverless",
					"express"
				],
				"series": "serverless",
				"date": "2017-02-27T00:00:00.000Z",
				"lang": "cn"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016/serverless",
				"base": "migrate-express-app-to-lambda.md",
				"ext": "md",
				"name": "migrate-express-app-to-lambda",
				"extname": ".md",
				"basename": "migrate-express-app-to-lambda.md",
				"dirname": "2016/serverless",
				"stem": "migrate-express-app-to-lambda",
				"path": "2016/serverless/migrate-express-app-to-lambda.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2016/serverless/migrate-express-app-to-lambda.md",
				"isAbsolute": false
			},
			"requirePath": "2016/serverless/migrate-express-app-to-lambda.md",
			"path": "/2016/serverless/migrate-express-app-to-lambda/",
			"data": {
				"title": "Serverless - getting started",
				"author": "jimmy yang",
				"tags": [
					"lambda",
					"serverless"
				],
				"series": "serverless",
				"date": "2016-01-01T00:00:00.000Z",
				"draft": true,
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017",
				"base": "product-tools-stack.md",
				"ext": "md",
				"name": "product-tools-stack",
				"extname": ".md",
				"basename": "product-tools-stack.md",
				"dirname": "2017",
				"stem": "product-tools-stack",
				"path": "2017/product-tools-stack.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/2017/product-tools-stack.md",
				"isAbsolute": false
			},
			"requirePath": "2017/product-tools-stack.md",
			"path": "/2017/product-tools-stack/",
			"data": {
				"title": "Product development tools stack",
				"author": "jimmy yang",
				"tags": [
					"js"
				],
				"series": "101",
				"date": "2017-04-24T00:00:00.000Z",
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "lib.js",
				"ext": "js",
				"name": "lib",
				"extname": ".js",
				"basename": "lib.js",
				"dirname": "",
				"stem": "lib",
				"path": "lib.js",
				"absolute": "/Users/jimmy/Desktop/serv/blog-gankkank/packages/simple-blog/lib.js",
				"isAbsolute": false
			},
			"requirePath": "lib.js",
			"path": "/lib/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 382
// module chunks = 0